// Local durable store for the offline-first POS.
// Inside the Electron desktop app this bridges to a local SQLite database (see /app/electron/db.js);
// in a plain browser it falls back to IndexedDB.
const DB_NAME = "matrixshopping_pos";
const DB_VERSION = 3;
const STORES = ["products", "sync_queue", "held_sales", "sales", "customers", "meta", "mobile_uploads", "online_orders"];

let dbp = null;
function open() {
  if (dbp) return dbp;
  dbp = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      STORES.forEach((s) => { if (!db.objectStoreNames.contains(s)) db.createObjectStore(s, { keyPath: "id" }); });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbp;
}

async function tx(store, mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(store, mode);
    const os = t.objectStore(store);
    const res = fn(os);
    t.oncomplete = () => resolve(res?._value !== undefined ? res._value : res);
    t.onerror = () => reject(t.error);
  });
}

function reqVal(request) {
  const box = { _value: undefined };
  request.onsuccess = () => { box._value = request.result; };
  return box;
}

const indexedStore = {
  async put(store, value) { return tx(store, "readwrite", (os) => { os.put(value); }); },
  async putAll(store, values) { return tx(store, "readwrite", (os) => { values.forEach((v) => os.put(v)); }); },
  async get(store, id) { return tx(store, "readonly", (os) => reqVal(os.get(id))); },
  async all(store) { return tx(store, "readonly", (os) => reqVal(os.getAll())); },
  async del(store, id) { return tx(store, "readwrite", (os) => { os.delete(id); }); },
  async clear(store) { return tx(store, "readwrite", (os) => { os.clear(); }); },
  async count(store) { return tx(store, "readonly", (os) => reqVal(os.count())); },
};

const sqliteBridge = typeof window !== "undefined" ? window.matrixPOS?.db : null;

export const isDesktop = Boolean(sqliteBridge);
export const storageEngine = isDesktop ? "sqlite" : "indexeddb";
export const idb = sqliteBridge || indexedStore;
